module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.errGif
    }
  })])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('h1', {
    staticClass: "font404 mt-5"
  }, [_vm._v("404")]), _vm._v(" "), _c('p', [_vm._v("你所查看的页面无法浏览或已经不存在")]), _vm._v(" "), _c('p', [_vm._v("输入的地址不正确")]), _vm._v(" "), _c('p', [_vm._v("页面重定义或程序出错")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("返回首页")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-434fff79"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/E404.vue
// module id = 598
// module chunks = 2